import React from 'react';
import { Flex } from '../Flex';
import { CircularProgress, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { HBox } from '../HBox';

export function LoadingPage({
  children,
  ...props
}) {
  const { t } = useTranslation()
  return (
    <HBox
      {...props}
    >
      <CircularProgress />
      <Typography variant="h6">{i18n.t('Loading')}</Typography>
      {children }
    </HBox>
  )
}